<template>
  <div class="col-12 bg-primary p-0 h-100">

    <div class="map-container">
      <div class="map-content">
        <div id='map' ref="map" class="mapbox m-0 p-0" style="height: 90vh"></div>
        <MapButtons :button-clicked="buttonClicked" :buttons="buttons"/>
        <MapControls />
        <div class="position-absolute coordsbar">
          <p class="py-1 px-3 m-0">{{ this.$store.state.liveLocator.miniCoordsBar }}</p>
        </div>
      </div>
      <LoadingDialog :show-loading-dialog="this.$store.state.liveLocator.loading"/>
      <BaseMapStylesDialog/>
      <MapOptionsDialog/>
    </div>

    <template v-if="endTime">
      <div class="session-note end">
        <span class="d-block text-right m-0 p-0"><span class="material-icons">info</span></span>
        <h3><strong>THIS SESSION HAS ENDED</strong></h3>
        <p class="">If you are concerned about this users location contact the correct authorities</p>
      </div>
    </template>
    <!-- IF SESSION = ENDED -->

    <!-- IF NO DATA RECEIVED -->
    <template v-if="dataLoaded && !geoJsonFeature && !endTime">
      <div class="session-note no-data">
        <span class="d-block text-right m-0 p-0"><span class="material-icons">info</span></span>
        <h3><strong>NO DATA RECEIVED YET</strong></h3>
        <p class="">The hiker may have share their Location link, but no GPS data has yet been received, please wait and then refresh the link.</p>
      </div>
    </template>

  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import BaseMapStylesDialog from '../../../apps/./base_map_dialog/BaseMapStylesDialog.vue';
import MapButtons from "../../components/MapButtons.vue";
import LoadingDialog from "../../../utils/shared_components/LoadingDialog.vue";
import MapOptionsDialog from "../../../apps/map_options_dialog/MapOptionsDialog.vue";
import MapControls from "../../components/MapControls.vue";
import {ThreeDimensionalMapManager} from "../../../utils/models/MapStyles";
import {OnBoardingGoal} from "../../../utils/models/OnBoardingGoal";
import {RevenueCatWrapper} from "../../../utils/RevenueCatWrapper";
import {Modal} from "bootstrap";
export default defineComponent({
  components: {MapControls, MapOptionsDialog, LoadingDialog, MapButtons, BaseMapStylesDialog },
  data() {
    return {
      hover: false,
      showChart: true,
      buttons: [
        { id: 0, name: 'Maps', icon: 'layers', enabled: false, dropIcon: true }
      ],
    };
  },
  props: {
    leftColHidden: {
      type: Boolean,
      default: false,
    },
    toggleMap: {
      type: Function,
      default: () => { },
    },
  },
  methods: {
    async _3dClicked() {
      // eslint-disable-next-line no-underscore-dangle
      const isProOrProPlus = await RevenueCatWrapper.isProOrProPlus();
      if (isProOrProPlus) {
        this.$store.dispatch('mapStyles/toggle3dMaps');
      } else {
        window.location.href = "/purchases"
      }
    },
    async buttonClicked(id: number) {
      const isProOrProPlus = await RevenueCatWrapper.isProOrProPlus();
      switch (id) {
        case 0:
          if (window.user) {
            const mapStylesDialog = document.getElementById("map-styles-dialog");
            const modal = new Modal(mapStylesDialog);
            modal.show();
          } else {
            window.onBoardingVue.launchFor(OnBoardingGoal.MapStyles);
          }
          break;
      }
    }
  },
  computed: {
    liveLocatorData() {
      return this.$store.state.liveLocator.liveLocatorData;
    },
    endTime() {
      return this.liveLocatorData ? this.liveLocatorData.endTime : null;
    },
    geoJsonFeature() {
      return this.$store.state.liveLocator.geoJsonFeature;
    },
    dataLoaded() {
      return this.$store.state.liveLocator.dataLoaded;
    },
    miniCoordsBar() {
      // @ts-ignore
      return this.$store.state.liveLocator.miniCoordsBar;
    },
  },
  watch: {
    _3dEnabled: function (newVal, oldVal) {
      this.buttons[1].enabled = newVal
    }
  }
});
</script>

<style scoped>

.coordsbar {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px 6px;
  font-size: .8em;
  background: rgb(27 27 29 / 90%);
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  z-index: 100;
  color: white;
}

.map-container {
  flex: 1 1 auto;
  max-width: 100%;
  z-index: 7;
}

.map-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.mapbox {
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 2;
}

.mapboxgl-ctrl-bottom-left {
  bottom: 10px !important;
}

.toggleSideBar {
  position: absolute;
  top: 1em;
  left: 1em;
  z-index: 10000;
}

.map-tools-container {
  position: absolute;
  right: 30px;
  bottom: 30px;
  z-index: 100;
  display: block;
}

.button-container {
  width: fit-content;
  top: 58px;
  right: 2%;
}

.session-note{
  color: #fff;
  position: absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  display: block;
  z-index: 111;
  width: 440px;
  height: fit-content;
  max-width: 90%;
  max-height: 180px;
  margin: auto;
  padding: 1.5em;
  border-radius: 8px;
}

.end{
  background-color: #DB2B35;
}

.no-data{
  background: #FFC107;
  color: #202020;
}

.session-note .text-right{
  text-align: right;
}

@media (max-width: 900px) {
  .toggleSideBar {
    top: 5.5em;
  }
}

</style>
